<div class="vm-accordion__card vm-accordion__modelone__card ">
  <div (click)="isCollapsable && (isExpanded = !isExpanded)" class="vm-accordion__card-header vm-accordion__modelone__card-header vm-accordion__modelone"
       [ngClass]="{ 'collapsed': !isExpanded }"
       data-toggle="collapse" data-target="#collapseOne"
       aria-expanded="true" aria-controls="collapseOne">
    <div class="vm-accordion__card-header-title" *ngIf="isHeader">
      <h4>{{ Name }}</h4>
    </div>
    <div class="vm-arrow"><span class="material-symbols-outlined vm-icons">expand_more</span></div>
  </div>
  <div id="collapseOne" class="vm-accordion__card-collapse collapse" [ngClass]="{ 'show': isExpanded }" aria-labelledby="protectionOne" data-parent="#keyProtection">
    <div class="vm-accordion__card-body" *ngIf="isExpanded">
      <ng-content></ng-content>
    </div>
  </div>
</div>
